/**
 * Página de sucursales Amarket (plantilla page.sucursales-amarket).
 *
 * Qué hace: obtiene el listado en apicloud, filtra solo marca Amarket (03),
 * dropdown por ciudad/departamento (por defecto Santa Cruz si viene en datos),
 * mapa Google y lista; orden por distancia Haversine si hay geolocalización.
 *
 * Depende de: clave Maps en el tema, asset amarket-pin.png opcional para íconos.
 */
(function () {
  'use strict';

  var CENTRO_PREDETERMINADO = { lat: -17.7839, lng: -63.1821 };
  var ZOOM_PREDETERMINADO = 12;
  var URL_API_SUCURSALES = 'https://apicloud.farmacorp.com/apishopifyamarket/api/v1.0/info/sucursales';

  /** Código de marca en API: solo "03" = Amarket (no 01 Farmacorp, 04 Pizza Hut, etc.). */
  var MARCA_FILTRO = '03';
  /** Sucursales ocultas por coincidencia exacta en descripción (normalizada). */
  var DESCRIPCIONES_EXCLUIDAS = [
    'SC - CF. AMARKET MINI URUBO',
    'SC- Montero 16 de Julio',
    'SC - Ventas Corporativas Amarket',
    'SC- CD Proxy Amarket Canal Isuto',
  ];

  /** Devuelve el contenedor raíz del módulo (ids en español en el Liquid). */
  function obtenerRaiz() {
    return document.getElementById('sucursales-amarket-raiz');
  }

  /**
   * Indica si el registro JSON debe mostrarse en esta página.
   * La API mezcla marcas; acá solo sucursales Amarket (marca 03).
   */
  function esMarcaAmarket(registro) {
    return String(registro.marca || '').trim() === MARCA_FILTRO;
  }

  /** Distancia en km entre dos puntos WGS84 (aproximación Haversine). */
  function distanciaHaversineKm(lat1, lon1, lat2, lon2) {
    var R = 6371;
    function aRadianes(grados) {
      return (grados * Math.PI) / 180;
    }
    var dLat = aRadianes(lat2 - lat1);
    var dLon = aRadianes(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(aRadianes(lat1)) * Math.cos(aRadianes(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  /**
   * Convierte una fila de la API al objeto que usa el mapa y la lista.
   * Devuelve null si faltan coordenadas válidas.
   */
  function normalizarSucursal(registro) {
    var lat = parseFloat(registro.coordenadax);
    var lng = parseFloat(registro.coordenaday);
    if (isNaN(lat) || isNaN(lng)) return null;
    return {
      codigo: registro.codigo || '',
      descripcion: registro.descripcion || '',
      departamento: registro.departamento || '',
      direccion: registro.direccion || '',
      telefono: registro.telefono || '',
      movil: registro.movil || '',
      horario: registro.horario || '',
      servicios: registro.servicios || '',
      urlImagen: registro.urlImagen || '',
      lat: lat,
      lng: lng,
      registroOriginal: registro,
    };
  }

  /** Ordena por distancia si hay usuario; si no, por nombre de sucursal. */
  function ordenarSucursales(lista, ubicacionUsuario) {
    var copia = lista.slice();
    if (ubicacionUsuario) {
      copia.forEach(function (s) {
        s._distanciaKm = distanciaHaversineKm(ubicacionUsuario.lat, ubicacionUsuario.lng, s.lat, s.lng);
      });
      copia.sort(function (a, b) {
        return a._distanciaKm - b._distanciaKm;
      });
    } else {
      copia.sort(function (a, b) {
        return (a.descripcion || '').localeCompare(b.descripcion || '', 'es', { sensitivity: 'base' });
      });
    }
    return copia;
  }

  /** URL de Google Maps con modo ruta hacia un par lat/lng (API externa, parámetros fijos). */
  function urlIndicacionesGoogleMaps(lat, lng) {
    return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(lat + ',' + lng);
  }

  /** Texto sin tildes para comparar departamentos (API puede variar mayúsculas). */
  function normalizarTextoDepartamento(texto) {
    return String(texto || '')
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  /** Normaliza texto para comparar descripciones sin depender de formato/capitalización. */
  function normalizarTextoDescripcion(texto) {
    return String(texto || '')
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ');
  }

  /** Excluye registros cuya descripción coincide con una sucursal que no debe mostrarse. */
  function esDescripcionExcluida(descripcion) {
    var descripcionNormalizada = normalizarTextoDescripcion(descripcion);
    return DESCRIPCIONES_EXCLUIDAS.some(function (item) {
      return normalizarTextoDescripcion(item) === descripcionNormalizada;
    });
  }

  /** Detecta si el valor de API corresponde a Santa Cruz (p. ej. "SANTA CRUZ", "Santa Cruz"). */
  function esDepartamentoSantaCruz(nombre) {
    var n = normalizarTextoDepartamento(nombre);
    return n.indexOf('santa cruz') !== -1;
  }

  /** Lista única de departamentos no vacíos, orden alfabético en español. */
  function obtenerDepartamentosUnicosDesdeSucursales(lista) {
    var visto = {};
    var salida = [];
    lista.forEach(function (s) {
      var d = String(s.departamento || '').trim();
      if (!d || visto[d]) return;
      visto[d] = true;
      salida.push(d);
    });
    salida.sort(function (a, b) {
      return a.localeCompare(b, 'es', { sensitivity: 'base' });
    });
    return salida;
  }

  /**
   * Valor inicial del select: Santa Cruz si existe en los datos; si no, todos (cadena vacía).
   */
  function valorDepartamentoPorDefecto(unicos) {
    var i;
    for (i = 0; i < unicos.length; i++) {
      if (esDepartamentoSantaCruz(unicos[i])) return unicos[i];
    }
    return '';
  }

  /**
   * Estado y DOM de la página de sucursales.
   * cfg: urlApi (opcional), urlPin para marcadores personalizados.
   */
  function PaginaSucursalesAmarket(cfg) {
    this.urlApi = cfg.urlApi || URL_API_SUCURSALES;
    this.urlPin = (cfg && cfg.urlPin) || '';
    this.elementoMapa = document.getElementById('sucursales-amarket-mapa');
    this.elementoLista = document.getElementById('sucursales-amarket-lista');
    this.elementoEstado = document.querySelector('.custom-sucursales-amarket__estado');
    this.botonGeo = document.querySelector('[data-geolocalizacion]');
    this.elementoMensajeGeo = document.querySelector('.custom-sucursales-amarket__mensaje-geo');
    this.selectDepto = document.getElementById('sucursales-amarket-filtro-depto');
    /** Valor exacto del campo departamento en API; '' = mostrar todos. */
    this.departamentoSeleccionado = '';
    this.mapa = null;
    this.marcadores = [];
    this.sucursales = [];
    this.ordenadas = [];
    this.ubicacionUsuario = null;
    this.marcadorUsuario = null;
    this.codigoActivo = null;
  }

  /** Mensaje bajo la lista (carga o error). */
  PaginaSucursalesAmarket.prototype.establecerEstado = function (texto, esError) {
    if (!this.elementoEstado) return;
    this.elementoEstado.textContent = texto || '';
    this.elementoEstado.classList.toggle('custom-sucursales-amarket__estado--error', !!esError);
  };

  /** Mensaje junto al botón de geolocalización. */
  PaginaSucursalesAmarket.prototype.establecerMensajeGeo = function (texto, esError) {
    if (!this.elementoMensajeGeo) return;
    this.elementoMensajeGeo.textContent = texto || '';
    this.elementoMensajeGeo.classList.toggle('custom-sucursales-amarket__mensaje-geo--error', !!esError);
  };

  /**
   * Descarga sucursales, filtra por marca 03 (Amarket), normaliza y dispara render.
   */
  PaginaSucursalesAmarket.prototype.cargarDatos = function () {
    var self = this;
    this.establecerEstado('Cargando sucursales…');
    return fetch(this.urlApi, { method: 'GET', credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('Error de red: ' + res.status);
        return res.json();
      })
      .then(function (json) {
        if (!json || json.type !== 'Success' || !Array.isArray(json.data)) {
          throw new Error('Respuesta inválida del servidor.');
        }
        var salida = [];
        json.data.forEach(function (fila) {
          if (!esMarcaAmarket(fila)) return;
          if (esDescripcionExcluida(fila.descripcion)) return;
          var n = normalizarSucursal(fila);
          if (n) salida.push(n);
        });
        return salida;
      })
      .then(function (lista) {
        self.sucursales = lista;
        self.construirDropdownDepartamentos();
        self.aplicarOrdenYRenderizado();
        self.establecerEstado('');
        return lista;
      })
      .catch(function (err) {
        console.error('Sucursales Amarket:', err);
        if (self.selectDepto) {
          self.selectDepto.innerHTML = '<option value="">No disponible</option>';
          self.selectDepto.disabled = true;
        }
        self.establecerEstado(
          'No se pudieron cargar las sucursales. Comprobá tu conexión o intentá más tarde.',
          true
        );
        throw err;
      });
  };

  /** Sucursales que pasan el filtro por departamento (mismo texto que devuelve la API). */
  PaginaSucursalesAmarket.prototype.obtenerSucursalesFiltradas = function () {
    var sel = this.departamentoSeleccionado;
    if (!sel) {
      return this.sucursales.slice();
    }
    return this.sucursales.filter(function (s) {
      return String(s.departamento || '').trim() === sel;
    });
  };

  /** Rellena el dropdown con departamentos existentes y deja Santa Cruz por defecto si aplica. */
  PaginaSucursalesAmarket.prototype.construirDropdownDepartamentos = function () {
    if (!this.selectDepto) return;
    var unicos = obtenerDepartamentosUnicosDesdeSucursales(this.sucursales);
    this.selectDepto.innerHTML = '';
    var optTodos = document.createElement('option');
    optTodos.value = '';
    optTodos.textContent = 'Todos los departamentos';
    this.selectDepto.appendChild(optTodos);
    unicos.forEach(function (nombre) {
      var opt = document.createElement('option');
      opt.value = nombre;
      opt.textContent = nombre;
      this.selectDepto.appendChild(opt);
    }, this);
    this.departamentoSeleccionado = valorDepartamentoPorDefecto(unicos);
    this.selectDepto.value = this.departamentoSeleccionado;
    this.selectDepto.disabled = false;
  };

  PaginaSucursalesAmarket.prototype.aplicarOrdenYRenderizado = function () {
    var filtradas = this.obtenerSucursalesFiltradas();
    if (
      this.codigoActivo &&
      !filtradas.some(function (x) {
        return x.codigo === this.codigoActivo;
      }, this)
    ) {
      this.codigoActivo = null;
    }
    this.ordenadas = ordenarSucursales(filtradas, this.ubicacionUsuario);
    this.renderizarLista();
    if (this.mapa) {
      this.actualizarMarcadores();
    }
  };

  PaginaSucursalesAmarket.prototype.vincularFiltroDepartamento = function () {
    var self = this;
    if (!this.selectDepto) return;
    this.selectDepto.addEventListener('change', function () {
      self.departamentoSeleccionado = self.selectDepto.value || '';
      self.aplicarOrdenYRenderizado();
    });
  };

  function agregarFilaDetalle(contenedor, etiqueta, valor) {
    if (!valor) return;
    var fila = document.createElement('div');
    fila.className = 'custom-sucursales-amarket__detalle-fila';
    var lab = document.createElement('span');
    lab.className = 'custom-sucursales-amarket__detalle-etiqueta';
    lab.textContent = etiqueta;
    var val = document.createElement('span');
    val.className = 'custom-sucursales-amarket__detalle-valor';
    val.textContent = valor;
    fila.appendChild(lab);
    fila.appendChild(val);
    contenedor.appendChild(fila);
  }

  PaginaSucursalesAmarket.prototype.renderizarLista = function () {
    var self = this;
    if (!this.elementoLista) return;
    this.elementoLista.innerHTML = '';
    if (this.ordenadas.length === 0 && this.sucursales.length > 0) {
      var liVacío = document.createElement('li');
      liVacío.className = 'custom-sucursales-amarket__lista-vacia';
      liVacío.setAttribute('role', 'status');
      liVacío.textContent = 'No hay sucursales en el departamento seleccionado.';
      this.elementoLista.appendChild(liVacío);
      return;
    }
    this.ordenadas.forEach(function (s) {
      var li = document.createElement('li');
      var tarjeta = document.createElement('div');
      tarjeta.className = 'custom-sucursales-amarket__tarjeta';
      tarjeta.setAttribute('data-codigo', s.codigo);
      tarjeta.setAttribute('role', 'button');
      tarjeta.setAttribute('tabindex', '0');
      tarjeta.setAttribute('aria-label', 'Ver en mapa: ' + (s.descripcion || s.codigo));
      if (self.codigoActivo === s.codigo) {
        tarjeta.classList.add('custom-sucursales-amarket__tarjeta--activa');
      }

      var cuerpo = document.createElement('div');
      cuerpo.className = 'custom-sucursales-amarket__tarjeta-cuerpo';

      var titulo = document.createElement('div');
      titulo.className = 'custom-sucursales-amarket__tarjeta-titulo';
      titulo.textContent = s.descripcion || s.codigo;
      cuerpo.appendChild(titulo);

      var detalles = document.createElement('div');
      detalles.className = 'custom-sucursales-amarket__detalles';
      agregarFilaDetalle(detalles, 'Dirección', s.direccion);
      agregarFilaDetalle(detalles, 'Ciudad / Depto.', s.departamento);
      agregarFilaDetalle(detalles, 'Teléfono', s.telefono);
      if (s.movil && String(s.movil).trim() !== String(s.telefono).trim()) {
        agregarFilaDetalle(detalles, 'Móvil', s.movil);
      }
      agregarFilaDetalle(detalles, 'Horario', s.horario);
      agregarFilaDetalle(detalles, 'Servicios', s.servicios);
      cuerpo.appendChild(detalles);

      if (self.ubicacionUsuario && typeof s._distanciaKm === 'number') {
        var dist = document.createElement('div');
        dist.className = 'custom-sucursales-amarket__tarjeta-distancia';
        dist.textContent = 'Aprox. ' + s._distanciaKm.toFixed(1) + ' km';
        cuerpo.appendChild(dist);
      }

      var acciones = document.createElement('div');
      acciones.className = 'custom-sucursales-amarket__tarjeta-acciones';
      var enlace = document.createElement('a');
      enlace.className = 'custom-sucursales-amarket__enlace-maps';
      enlace.href = urlIndicacionesGoogleMaps(s.lat, s.lng);
      enlace.target = '_blank';
      enlace.rel = 'noopener noreferrer';
      enlace.textContent = 'Cómo llegar en Google Maps';
      enlace.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      acciones.appendChild(enlace);
      cuerpo.appendChild(acciones);

      tarjeta.appendChild(cuerpo);
      tarjeta.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        self.enfocarSucursal(s.codigo);
      });
      tarjeta.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (e.target.closest('a')) return;
          self.enfocarSucursal(s.codigo);
        }
      });

      li.appendChild(tarjeta);
      self.elementoLista.appendChild(li);
    });
  };

  PaginaSucursalesAmarket.prototype.inicializarMapa = function () {
    if (!this.elementoMapa || !window.google || !window.google.maps) return;
    this.mapa = new google.maps.Map(this.elementoMapa, {
      center: CENTRO_PREDETERMINADO,
      zoom: ZOOM_PREDETERMINADO,
      mapTypeControl: true,
      streetViewControl: true,
      fullscreenControl: true,
    });

    this.actualizarMarcadores();
  };

  PaginaSucursalesAmarket.prototype.actualizarMarcadores = function () {
    var self = this;
    if (!this.mapa) return;

    this.marcadores.forEach(function (m) {
      m.setMap(null);
    });
    this.marcadores = [];

    var limites = new google.maps.LatLngBounds();
    var hayPuntos = false;

    this.ordenadas.forEach(function (s) {
      var pos = { lat: s.lat, lng: s.lng };
      var opcionesMarcador = {
        position: pos,
        map: self.mapa,
        title: s.descripcion || s.codigo,
      };
      if (self.urlPin && google.maps.Size && google.maps.Point) {
        opcionesMarcador.icon = {
          url: self.urlPin,
          scaledSize: new google.maps.Size(40, 52),
          anchor: new google.maps.Point(20, 52),
        };
      }
      var marcador = new google.maps.Marker(opcionesMarcador);
      marcador.addListener('click', function () {
        self.enfocarSucursal(s.codigo, false);
      });
      self.marcadores.push(marcador);
      limites.extend(pos);
      hayPuntos = true;
    });

    // Sin ubicación del usuario: encuadramos las sucursales visibles. Con GPS, no re-ajustamos para no alejar el zoom.
    if (!this.ubicacionUsuario && hayPuntos && this.ordenadas.length > 1) {
      this.mapa.fitBounds(limites);
    } else if (!this.ubicacionUsuario && hayPuntos && this.ordenadas.length === 1) {
      this.mapa.setCenter({ lat: this.ordenadas[0].lat, lng: this.ordenadas[0].lng });
      this.mapa.setZoom(14);
    } else if (!this.ubicacionUsuario && !hayPuntos) {
      this.mapa.setCenter(CENTRO_PREDETERMINADO);
      this.mapa.setZoom(ZOOM_PREDETERMINADO);
    }

    if (this.ubicacionUsuario) {
      if (this.marcadorUsuario) this.marcadorUsuario.setMap(null);
      this.marcadorUsuario = new google.maps.Marker({
        position: this.ubicacionUsuario,
        map: this.mapa,
        title: 'Tu ubicación',
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 8,
          fillColor: '#0d7a4e',
          fillOpacity: 0.85,
          strokeColor: '#fff',
          strokeWeight: 2,
        },
      });
    }
  };

  PaginaSucursalesAmarket.prototype.enfocarSucursal = function (codigo, animarPaneo) {
    var s = this.ordenadas.find(function (x) {
      return x.codigo === codigo;
    });
    if (!s || !this.mapa) return;

    this.codigoActivo = codigo;
    this.renderizarLista();

    var pos = { lat: s.lat, lng: s.lng };
    if (animarPaneo !== false) {
      this.mapa.panTo(pos);
    } else {
      this.mapa.setCenter(pos);
    }
    this.mapa.setZoom(Math.max(this.mapa.getZoom(), 15));

    var tarjetaActiva = null;
    if (this.elementoLista) {
      try {
        tarjetaActiva = this.elementoLista.querySelector(
          '[data-codigo="' + String(codigo).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]'
        );
      } catch (e) {
        tarjetaActiva = null;
      }
    }
    if (tarjetaActiva && tarjetaActiva.scrollIntoView) {
      tarjetaActiva.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  };

  PaginaSucursalesAmarket.prototype.solicitarGeolocalizacion = function () {
    var self = this;
    if (!('geolocation' in navigator)) {
      this.establecerMensajeGeo('Tu navegador no permite obtener la ubicación.', true);
      return;
    }

    this.establecerMensajeGeo('Obteniendo ubicación…');

    navigator.geolocation.getCurrentPosition(
      function (pos) {
        self.ubicacionUsuario = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };
        self.establecerMensajeGeo('Ubicación activa. Ordenamos las sucursales por distancia aproximada.');
        self.aplicarOrdenYRenderizado();
        if (self.mapa) {
          self.actualizarMarcadores();
          self.mapa.panTo(self.ubicacionUsuario);
          self.mapa.setZoom(13);
        }
      },
      function (err) {
        var msg = 'No pudimos obtener tu ubicación.';
        if (err && err.code === 1) msg = 'Permiso de ubicación denegado. Podés activarlo en la configuración del navegador.';
        else if (err && err.code === 2) msg = 'Ubicación no disponible en este momento.';
        else if (err && err.code === 3) msg = 'Tiempo de espera agotado al obtener la ubicación.';
        self.establecerMensajeGeo(msg, true);
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 60000 }
    );
  };

  PaginaSucursalesAmarket.prototype.vincularBotonGeolocalizacion = function () {
    var self = this;
    if (!this.botonGeo) return;
    this.botonGeo.addEventListener('click', function () {
      self.solicitarGeolocalizacion();
    });

    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions
        .query({ name: 'geolocation' })
        .then(function (status) {
          if (status.state === 'denied') {
            self.establecerMensajeGeo(
              'El permiso de ubicación está bloqueado. Activá la ubicación en la configuración del sitio.',
              true
            );
          }
        })
        .catch(function () {});
    }
  };

  /**
   * Carga el script de la API de Maps si aún no está; luego ejecuta el callback.
   * Nombres de API de Google se respetan (obligación técnica).
   */
  function cargarScriptGoogleMaps(clave, alListo) {
    if (window.google && window.google.maps) {
      alListo();
      return;
    }
    var nombreCallback = '__mapasSucursalesAmarketIniciar';
    window[nombreCallback] = function () {
      try {
        alListo();
      } finally {
        delete window[nombreCallback];
      }
    };
    var script = document.createElement('script');
    script.async = true;
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=' +
      encodeURIComponent(clave) +
      '&callback=' +
      nombreCallback;
    script.onerror = function () {
      delete window[nombreCallback];
      var raiz = obtenerRaiz();
      if (raiz) {
        var st = raiz.querySelector('.custom-sucursales-amarket__estado');
        if (st) {
          st.textContent = 'No se pudo cargar Google Maps. Verificá la clave de API.';
          st.classList.add('custom-sucursales-amarket__estado--error');
        }
      }
    };
    document.head.appendChild(script);
  }

  function iniciar() {
    var raiz = obtenerRaiz();
    if (!raiz) return;

    var clave = raiz.getAttribute('data-clave-mapa');
    if (!clave) {
      var st = raiz.querySelector('.custom-sucursales-amarket__estado');
      if (st) {
        st.textContent = 'Falta configurar la clave de Google Maps en el tema.';
        st.classList.add('custom-sucursales-amarket__estado--error');
      }
      return;
    }

    var urlApi = raiz.getAttribute('data-url-api') || URL_API_SUCURSALES;
    var urlPin = raiz.getAttribute('data-url-pin') || '';
    var pagina = new PaginaSucursalesAmarket({ urlApi: urlApi, urlPin: urlPin });
    pagina.vincularFiltroDepartamento();
    pagina.vincularBotonGeolocalizacion();

    cargarScriptGoogleMaps(clave, function () {
      pagina.inicializarMapa();
      pagina.cargarDatos().catch(function () {
        /* el error ya se mostró en pantalla */
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
